"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetContainer = void 0;
const theme_1 = require("@pulse-web-ui/theme");
exports.WidgetContainer = theme_1.styled.div `
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.surface.primary};
  padding: 20px 16px;
  border-radius: calc(${({ theme }) => theme.common.radius} * 6);
  width: 100%;
  max-width: 768px;

  ${theme_1.media.desktop} {
    padding: 24px;
  }
`;
